import React, { useState } from "react"
import HomeContainer from "../Container/HomeContainer2"
import TeacherResume from "./TeacherResume.redux"
import Spinner from "../../Components/Spinner/Spinner"

const SharedResume = (props) => {
  const [user, setUSer] = useState(props.location.data)

  if (user) {
    return (
      <HomeContainer
        isViewAsTeacher={false}
        footer={null}
        isShowWhereby={false}
        isShowPoliceCheckWwcc={true}
        tabResumeActive={true}
        isShared
        user={user}
      >
        <TeacherResume
          user={user}
          isViewAsTeacher={false}
        />
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

export default SharedResume
